module.exports = __webpack_public_path__ + "static/media/workout-generator-thumbnail.a85c51ee.png";